module.exports = __webpack_public_path__ + "img/preview.c498d277.jpg";